export default __webpack_public_path__ + "static/media/source-logo-moodle.df8f2156.png";